import type { ExistingVendor, Vendor } from '../vendorTypes';

export const deleteUnsavedAttribute = (
  row: Vendor | ExistingVendor,
): Vendor => {
  if (row.unsaved) {
    if ('id' in row) {
      const { id, unsaved, ...rest } = row;
      return rest;
    }

    const { unsaved, ...rest } = row;
    return rest;
  }

  return row;
};
